import { IHistoryGet } from 'types/types';

export const historyNormalization = (data: IHistoryGet) => {
  const { size, page, ascending, sortBy } = data;
  return `?size=${size ?? 0}&page=${page ?? 0}&ascending=${!!ascending}&sortBy=${
    sortBy ? sortBy : 'createdAt'
  }`;
};
